import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { FaFacebook, FaInstagram,  FaEnvelope, FaWhatsapp } from "react-icons/fa";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* 🔹 SEO e Schema.org */}
      <Helmet>
        <title>{t("footer.title")}</title>
        <meta name="description" content={t("footer.description")} />
        <meta name="keywords" content={t("footer.keywords")} />
        <meta name="author" content="Andromeda Programmazione" />
        <meta name="robots" content="index, follow" />

        {/* Schema.org LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Andromeda Programmazione",
            "url":  "https://www.andromedaprog.it/",
            "telephone": "+39 328 318 7865",
            "email": "info@andromedaprog.it",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Esempio 10",
              "addressLocality": "San Cesario di Lecce",
              "addressRegion": "LE",
              "postalCode": "73016",
              "addressCountry": "IT"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "40.311",
              "longitude": "18.162"
            },
            "sameAs": [
              "mailto:info@andromedaprog.it",
              "https://wa.me/393283187865",
              "https://www.linkedin.com"
            ],
            "description": t("footer.description"),
            "openingHours": "Mo-Fr 09:00-18:00",
            "priceRange": "€€"
          })}
        </script>
      </Helmet>

      {/* 🔹 Contenuto del footer */}
      <footer className="footer py-4 bg-dark text-center text-light">
        <div className="container">
          <h5 className="fw-bold mb-2">{t("footer.brand")}</h5>
          <p className="mb-2">{t("footer.subtitle")}</p>

          {/* 🔹 Social e contatti */}
          <div className="Footer-social">
            <a href="mailto:info@andromedaprog.it" className="text-light me-3" title={t("footer.emailTitle")}>
              <FaEnvelope />
            </a>

            <a href="https://wa.me/393283187865" className="text-light me-3" title={t("footer.whatsappTitle")} target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>

           

            <a href="https://www.facebook.com/profile.php?id=61584063502089" className="text-light me-3" title={t("footer.facebookTitle")} target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>

            <a href="https://www.instagram.com/andromedaprog/" className="text-light" title={t("footer.instagramTitle")} target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>

          {/* 🔹 Copyright */}
          <small className="text-muted">
            © {currentYear} Andromeda Programmazione — {t("footer.rights")}
          </small>
        </div>
      </footer>
    </>
  );
}

export default Footer;
